// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-box[data-v-3715fa88] {\n  float: left;\n  padding: 0.3125rem 0.625rem;\n  border-radius: 1.25rem;\n  box-sizing: content-box;\n  background: #e6f1ff;\n}\n.radio-box span[data-v-3715fa88] {\n  padding: 0.3125rem 1.25rem;\n  height: 1.875rem;\n  text-align: center;\n  color: #0e75fe;\n  cursor: pointer;\n}\n.radio-box .active-box[data-v-3715fa88] {\n  border-radius: 1.25rem;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
